import { useAuthState } from "@/modules/auth/presentation/model/useAuthState";
import { usePermissions } from "@/modules/auth/presentation/model/usePermissions";
import { Permissions } from "@/modules/roles/domain/contracts/permissions";
import { cn } from "@devhop/ui";
import { dashboardLayout } from "../lib/dashboard-layout";
import { DashboardDocumentsPanel } from "./DashboardDocumentsPanel";
import { DashboardMyWorkPanel } from "./DashboardMyWorkPanel";

/** ແຖວລຸ່ມ: ເອກະສານ + ວຽກຂອງຂ້ອຍ — ເຕັມກວ້າງ ຖ້າມີແຕ່ສ່ວນໃດສ່ວນໜຶ່ງ */
export function DashboardBottomPanels() {
  const { user } = useAuthState();
  const { has, hasAny } = usePermissions();

  const showDocuments = has(Permissions.quotation_invoice.read);
  const showMyWork =
    Boolean(user?.id) &&
    hasAny([
      Permissions.mgmt_calendar.read,
      Permissions.mgmt_calendar.team,
    ]);

  if (!showDocuments && !showMyWork) return null;

  const twoCols = showDocuments && showMyWork;

  return (
    <div
      className={cn(
        dashboardLayout.pageStack,
        twoCols && "xl:grid xl:grid-cols-2 xl:items-start xl:gap-6",
      )}
    >
      {showDocuments ? <DashboardDocumentsPanel /> : null}
      {showMyWork ? <DashboardMyWorkPanel /> : null}
    </div>
  );
}
